// ConfiguratorContext.tsx
import { createContext, ReactNode, useContext, useState } from 'react';

import { Language } from '../../translations/translations';

interface ConfiguratorContextType {
  lang: Language;
  setLang: (value: Language) => void;
  pipeSize: string | null;
  setPipeSize: (value: string | null) => void;
  sport: string | null;
  setSport: (value: string | null) => void;
  handle: string | null;
  setHandle: (value: string | null) => void;
}

const ConfiguratorContext = createContext<ConfiguratorContextType | undefined>(
  undefined,
);

// eslint-disable-next-line react-refresh/only-export-components
export const useConfiguratorContext = () => {
  const context = useContext(ConfiguratorContext);
  if (!context) throw new Error('Error configuratorContext');
  return context;
};

export const ConfiguratorProvider = ({ children }: { children: ReactNode }) => {
  const [sport, setSport] = useState<string | null>(null);
  const [lang, setLang] = useState<Language>('it');
  const [handle, setHandle] = useState<string | null>(null);
  const [pipeSize, setPipeSize] = useState<string | null>(null);

  return (
    <ConfiguratorContext.Provider
      value={{
        sport,
        setSport,
        handle,
        setHandle,
        pipeSize,
        setPipeSize,
        lang,
        setLang,
      }}
    >
      {children}
    </ConfiguratorContext.Provider>
  );
};
